/**
 * Created by HYL.
 * 登录相关api
 */
import * as API from './'

export default {
  //查询获取所有区县机构列表
  orgTypeAndCode_list: params => {
    return API.GET('/api/orgTypeAndCode_list', params)
  },
  //查询获取所有区县机构列表2
  orgTypeAndCode_list2: params => {
    return API.GET('/api/orgTypeAndCode2_list', params)
  },
  //同意某些协议
  agree: params => {
    return API.POST('/api/org/agree', params)
  },
  //注册
  reg: params => {
    return API.POST('/api/reg/add', params)
  },
  //验证码
  defaultKaptcha: params => {
    return API.GET('/api/defaultKaptcha', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/api_login.js